/*
 * Home: today's visits, and business health (job value this week against last week, visits coming up).
 */
import { z } from "zod";
import { PLAN_OFFER_OPENERS } from "./plan-offer.js";

export const homeVisit = z.object({
  jobId: z.uuid(),
  date: z.string(),
  startTime: z.string().nullable(),
  clientName: z.string(),
  address: z.string().nullable(),
  jobName: z.string(),
  crew: z.array(z.string()),
  valueCents: z.number(),
});

export const homeAnswer = z.object({
  today: z.string(),
  todayVisits: z.array(homeVisit),
  todayValueCents: z.number(),
  weekValueCents: z.number(),
  lastWeekValueCents: z.number(),
  weekVisits: z.number(),
  lastWeekVisits: z.number(),
  /** The past 30 days (today and the 29 before), and the 30 days before those, for Business health on the phone Home. */
  monthValueCents: z.number(),
  lastMonthValueCents: z.number(),
  monthVisits: z.number(),
  lastMonthVisits: z.number(),
  nextSevenDaysVisits: z.number(),
  activeClients: z.number(),
  activeJobs: z.number(),
});
export type HomeAnswer = z.infer<typeof homeAnswer>;

/**
 * A Home To do item opened as a list you can fix from (owner, 2026-11-02: "help me actually fix these problems and not
 * just tell me"). Each row is one real visit, client, invoice or quote, with why it is on the list and what can be done.
 */
export const TODO_KINDS = [
  "late_visits",
  "no_crew",
  "idle_clients",
  "past_due",
  "awaiting",
  "quotes_waiting",
  "to_check",
  "plan_offers",
] as const;
export type TodoKind = (typeof TODO_KINDS)[number];
export const todoItem = z.object({
  /** The visit ref, or the client, invoice or quote id. */
  id: z.string(),
  clientId: z.uuid().nullable(),
  title: z.string(),
  /** When and where, or the invoice or quote number and what it is for. */
  sub: z.string(),
  /** Why it is on the list, in plain words. */
  why: z.string(),
  amountCents: z.number().nullable(),
  phone: z.string().nullable(),
  email: z.string().nullable(),
  /** text or email: how the client likes to hear from us. */
  prefers: z.enum(["text", "email"]).nullable(),
  /** The client's saved card, to charge an invoice from the list. */
  cardLast4: z.string().nullable(),
  /** Days late or days waiting, for sorting and the red mark. */
  days: z.number().nullable(),
  /** Clients with nothing booked: their quote still out (draft, sent or said yes), opened from the row. */
  quoteId: z.uuid().nullable().optional(),
  /** Plan offers to send: the opener that fits and the request it answers. */
  offer: z
    .object({ opener: z.enum(PLAN_OFFER_OPENERS), leadId: z.uuid().nullable() })
    .nullable()
    .optional(),
});
export type TodoItem = z.infer<typeof todoItem>;
export const todoList = z.object({ kind: z.enum(TODO_KINDS), items: z.array(todoItem) });
export type TodoList = z.infer<typeof todoList>;
